/**
 * Marks English text in shared, backend and data modules that the portal shows, so the app's
 * message catalog (packages/app/vite/messageCatalog.ts) extracts it and the portal can translate it
 * where it renders (`useTranslateText()` from `#i18n`). Returns the text unchanged: the API, events,
 * emails and logs keep English. Only a string literal argument is extracted.
 */
export const msg = <const Text extends string>(text: Text): Text => text;
